import type { UpgradeEffect } from './types';

/** An Ascension perk — bought with Cores, persists across prestige (mirrors SkillDef). */
export interface AscensionPerkDef {
  id: string;
  name: string;
  icon: string;
  description: string;
  maxLevel: number;
  /** Core cost of the first level; grows geometrically. */
  baseCost: number;
  costGrowth: number;
  effect: UpgradeEffect;
  requires?: { perk?: [string, number] };
}

export const ASCENSION_PERKS: readonly AscensionPerkDef[] = [
  {
    id: 'motherlode', name: 'Hauptader', icon: '⛰️', maxLevel: 20,
    baseCost: 1, costGrowth: 1.5,
    description: '+30% Abbau pro Stufe.',
    effect: { type: 'autoMult', value: 1.3 },
  },
  {
    id: 'tycoon', name: 'Tycoon-Instinkt', icon: '💎', maxLevel: 20,
    baseCost: 1, costGrowth: 1.5,
    description: '+30% Verkaufswert pro Stufe.',
    effect: { type: 'valueMult', value: 1.3 },
  },
  {
    id: 'midas', name: 'Midas-Berührung', icon: '👑', maxLevel: 15,
    baseCost: 2, costGrowth: 1.6,
    description: '+40% Klickkraft pro Stufe.',
    effect: { type: 'clickMult', value: 1.4 },
  },
  {
    id: 'fusion', name: 'Fusionskern', icon: '🔋', maxLevel: 15,
    baseCost: 3, costGrowth: 1.6,
    description: '+30% Energie pro Stufe.',
    effect: { type: 'energyMult', value: 1.3 },
    requires: { perk: ['motherlode', 3] },
  },
  {
    id: 'singularity', name: 'Singularität', icon: '🌌', maxLevel: 10,
    baseCost: 10, costGrowth: 1.8,
    description: '+50% auf alles pro Stufe (global).',
    effect: { type: 'globalMult', value: 1.5 },
    requires: { perk: ['tycoon', 5] },
  },
  {
    id: 'alchemy', name: 'Transmutation', icon: '⚗️', maxLevel: 15,
    baseCost: 4, costGrowth: 1.6,
    description: '+35% Verhüttung pro Stufe.',
    effect: { type: 'smeltMult', value: 1.35 },
    requires: { perk: ['midas', 2] },
  },
  {
    id: 'eventhorizon', name: 'Ereignishorizont', icon: '🕳️', maxLevel: 8,
    baseCost: 25, costGrowth: 2.0,
    description: '+75% auf alles pro Stufe (global).',
    effect: { type: 'globalMult', value: 1.75 },
    requires: { perk: ['singularity', 5] },
  },
] as const;

export const ASCENSION_PERK_BY_ID: Record<string, AscensionPerkDef> = Object.fromEntries(
  ASCENSION_PERKS.map((p) => [p.id, p]),
);
